import colors from '../../../../styles/colors.module.scss';

export const vasScaleOptions = [
  {
    rating: 1,
    text: 'Minimal',
    color: colors.primary,
  },
  {
    rating: 2,
    text: 'Uncomfortable',
    color: '#6BAE57',
  },
  {
    rating: 3,
    text: 'Mild',
    color: '#B4B837',
  },
  {
    rating: 4,
    text: 'Distressing',
    color: '#FCC317',
  },
  {
    rating: 5,
    text: 'Tolerable',
    color: '#FBAD1D',
  },
  {
    rating: 6,
    text: 'Moderate',
    color: '#F89229',
  },
  {
    rating: 7,
    text: 'Intense',
    color: '#FA8029',
  },
  {
    rating: 8,
    text: 'Severe',
    color: '#FB6E29',
  },
  {
    rating: 9,
    text: 'Extreme',
    color: '#FD5B29',
  },
  {
    rating: 10,
    text: 'Unbearable',
    color: '#FE4929',
  },
];
